import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const sections = [
  { path: '/' },
  { path: '/marche' },
  { path: '/vision' },
  { path: '/produit' },
  { path: '/propriete-intellectuelle' },
  { path: '/paiements' },
  { path: '/plan-execution' },
  { path: '/gtm' },
  { path: '/roadmap' },
  { path: '/resume-executif' },
  { path: '/modele' },
  { path: '/organisation' },
  { path: '/valorisation' },
  { path: '/levee-de-fonds' },
  { path: '/synthese-investisseur' },
  { path: '/previsions' }
];

export default function SwipeNavigation({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isNavigatingRef = React.useRef(false);
  const touchStartRef = React.useRef({ x: 0, y: 0, time: 0 });

  const minSwipeDistance = 100;
  const maxSwipeTime = 400;

  const currentIndex = sections.findIndex(s => s.path === location.pathname);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      isNavigatingRef.current = false;
    }, 600);
    
    return () => clearTimeout(timer);
  }, [location.pathname]);

  const handleTouchStart = (e) => {
    if (e.touches.length !== 1 || isNavigatingRef.current) return;
    
    touchStartRef.current = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
      time: Date.now()
    };
  };

  const handleTouchEnd = (e) => {
    if (isNavigatingRef.current || !touchStartRef.current.time) return;
    
    const touchEnd = {
      x: e.changedTouches[0].clientX,
      y: e.changedTouches[0].clientY,
      time: Date.now()
    };
    
    const deltaX = touchStartRef.current.x - touchEnd.x;
    const deltaY = Math.abs(touchStartRef.current.y - touchEnd.y);
    const deltaTime = touchEnd.time - touchStartRef.current.time;
    const absDeltaX = Math.abs(deltaX);
    
    touchStartRef.current = { x: 0, y: 0, time: 0 };
    
    if (absDeltaX < minSwipeDistance) return;
    if (deltaTime > maxSwipeTime) return;
    if (deltaY > absDeltaX * 0.3) return;
    
    if (deltaX > 0 && currentIndex < sections.length - 1) {
      isNavigatingRef.current = true;
      navigate(sections[currentIndex + 1].path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (deltaX < 0 && currentIndex > 0) {
      isNavigatingRef.current = true;
      navigate(sections[currentIndex - 1].path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  React.useEffect(() => {
    const element = document.getElementById('swipe-container');
    if (!element) return;

    element.addEventListener('touchstart', handleTouchStart, { passive: true });
    element.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      element.removeEventListener('touchstart', handleTouchStart);
      element.removeEventListener('touchend', handleTouchEnd);
    };
  }, [currentIndex]);

  return (
    <div id="swipe-container" className="min-h-screen">
      {children}
    </div>
  );
}
